var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconServices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.632 3.361a1.738 1.738 0 0 1 0 2.456L11.952 9.5l3.68 3.683a1.738 1.738 0 0 1 0 2.456 1.733 1.733 0 0 1-2.453 0L9.5 11.956 5.82 15.639a1.733 1.733 0 0 1-2.453 0 1.738 1.738 0 0 1 0-2.456L7.047 9.5l-3.68-3.683a1.738 1.738 0 0 1 0-2.456 1.733 1.733 0 0 1 2.453 0L9.5 7.044l3.68-3.683a1.733 1.733 0 0 1 2.452 0z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconServices);
export default __webpack_public_path__ + "static/media/closeIconServices.68f5d23e827f4e2524aced8ca8e52139.svg";
export { ForwardRef as ReactComponent };